import { composeEntityDrawerApiActions } from '@bp/admins-shared/features/entity';

import type { Preset } from '../../models';

export const ACTIONS_SCOPE = '[Drawer][Preset]';

const scope = `[API]${ ACTIONS_SCOPE }`;

export const PRESET_DRAWER_API_ACTIONS = composeEntityDrawerApiActions<Preset>(scope);
